<template>
    <div class="w-75 mb-5 meeting-note">
        <TextArea
            id="meetingNote"
            name="Meeting Note"
            label="Note"
            labelClass="appt-section-title"
            labelOptionalText="Optional"
            labelOptionalTextClass="label-optional-text"
            inputClass="top-5 w-100"
            placeholder="Paste the full meeting invitation, dial-in details, agenda, or other context"
            :rows="8"
            :cols="50"
            :limit="16000"
            :value="meetingNote"
            @input="updateMeetingNote"
        />
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'MeetingNote',
        computed: {
            ...mapState('eventEditor', {
                meetingNote: (state) => state.event.meeting_note ?? '',
            }),
        },
        methods: {
            ...mapActions('eventEditor', {
                updateMeetingNote: 'updateMeetingNote',
            }),
        },
    };
</script>
